import React from 'react';
import { adopt } from 'react-adopt';
import { Query } from '@apollo/react-components';
import gql from 'graphql-tag';
import get from 'lodash/get';

import { ContributePageConsumer } from '../context';
import ContributePageSEO from './contribute-seo';

const GET_CAMPAIGN = gql`
    query CampaignById($id: ID!) {
        campaign: campaignById(id: $id) {
            id
            name
            heroImage {
                id
            }
        }
    }
`;

/* eslint-disable react/prop-types, react/destructuring-assignment */
const Wrapper = adopt(
    {
        context: <ContributePageConsumer />,
        campaignQuery: ({ context, render }) => (
            <Query query={GET_CAMPAIGN} variables={{ id: context.campaign.id }}>
                {render}
            </Query>
        ),
    },
    ({ context, campaignQuery }) => ({
        error: campaignQuery.error,
        loading: campaignQuery.loading,
        campaign: {
            ...context.campaign,
            ...get(campaignQuery, 'data.campaign', {}),
        },
        contribution: context.contribution,
    })
);
/* eslint-enable react/prop-types, react/destructuring-assignment */

const ContributePageSEOContainer = () => (
    <Wrapper>
        {({ error, loading, campaign, contribution }) => {
            if (error) throw error;
            if (loading) return null;
            const isPledge = contribution.type === 'pledge';

            return (
                <ContributePageSEO
                    title={`${isPledge ? 'Pledge' : 'Donate'} to "${campaign.name}`}
                    name={campaign.name}
                    image={get(campaign, 'heroImage.publicId')}
                />
            );
        }}
    </Wrapper>
);

export default ContributePageSEOContainer;
